import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import {IPatient, Patient} from '../Patient.ts';
import {HealthcareProfessionalsApi} from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import {useSessionProvider} from '../../../provider/sessionContext.tsx';

export function useGetPatients() {
    const {currentUser} = useSessionProvider()

    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.patient, currentUser?.selectedHealthcareFacilityID],
        queryFn: async () => {
            const result: IPatient[] = await HealthcareProfessionalsApi.getPatients(
                currentUser!.healthcareProfessionalID!,
                currentUser?.selectedHealthcareFacilityID ?? undefined
            );
            return result ? result.map((x) => new Patient(x)) : result;
        },
        enabled: !!currentUser && !!currentUser?.healthcareProfessionalID
    });
}